import { ERROR_TEXT_GEO, ERROR_TEXT_GEO_DEFAULT } from 'constants/messages'

import NearMeIcon from '@mui/icons-material/NearMe'
import SearchIcon from '@mui/icons-material/Search'
import classNames from 'classnames'
import { SetPageTypeProps } from 'feature/serviceCenters/types'
import { getUserGeolocation } from 'feature/YandexMap/lib/getUserGeolocation'
import { useSetNotice } from 'hooks/useSetNotice'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { useActions } from 'store/hooks'
import { Button } from 'ui'
import { LoaderInCentalPosition } from 'widget/LoaderInCentalPosition/LoaderInCentalPosition'
import { Severity } from 'widget/Notifications'

import style from './ServiceSearchButtons.module.scss'

// блок с кнопками поиска сц
export function ServiceSearchButtons({ setPageType }: SetPageTypeProps) {
  const [isGeoLoading, setGeoLoading] = useState<boolean>(false)
  const navigate = useNavigate()
  const { setUserGeo } = useActions()
  const setNotice = useSetNotice()

  const getUserGeoSuccess = (position: GeolocationPosition | undefined) => {
    if (!position) return
    const { latitude, longitude } = position.coords
    setUserGeo({ coords: [+latitude, +longitude] })
    setGeoLoading(false)
    navigate(
      `/servicecenters/geo-address?geo-lat=${latitude}&geo-lon=${longitude}`,
    )
  }

  const getUserGeoError = (err: GeolocationPositionError) => {
    setGeoLoading(false)

    const errorText = err.code === 1 ? ERROR_TEXT_GEO : ERROR_TEXT_GEO_DEFAULT
    setNotice(errorText, Severity.error)
  }

  const getUserGeoHandler = () => {
    setGeoLoading(true)
    getUserGeolocation({
      successFunction: getUserGeoSuccess,
      errorFunction: getUserGeoError,
    })
  }

  return (
    <div className={style.serviceButtonBlock}>
      <Button
        variant='contained'
        className={style.searchButton}
        color='secondary'
        onClick={() => setPageType('address')}
        startIcon={<SearchIcon color='primary' />}
        data-testid='sc-search-address-btn'
      >
        Найти ближайший по адресу
      </Button>
      <Button
        onClick={getUserGeoHandler}
        variant='text'
        className={classNames(
          style.geoButton,
          isGeoLoading && style.disableGeoBitn,
        )}
        startIcon={<NearMeIcon color='primary' />}
        data-testid='sc-search-geo-btn'
      >
        {isGeoLoading && <LoaderInCentalPosition />}
        Ближайший по геопозиции
      </Button>
    </div>
  )
}
